// removed by extract-text-webpack-plugin
module.exports = {"Main":"unconfirmed__Main__2ZZvf"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Unconfirmed/unconfirmed.css
// module id = 1687
// module chunks = 2